/**
 * window.dfp_config.keywords might not be defined when we check.
 * For example, on Techradar, the script is loaded before the dfp_config is set.
 * So check until it is defined, but wait at most 1 second.
 */
export const getKeywords = (): Promise<string[]> =>
  new Promise((resolve) => {
    let count = 0;
    const interval = setInterval(() => {
      if (window.dfp_config?.keywords?.length) {
        // Config found so return the keywords
        clearInterval(interval);
        resolve(window.dfp_config.keywords.split(','));
      } else if (count > 5) {
        // Don't wait any longer and return an empty []
        clearInterval(interval);
        resolve([]);
      }
      count++;
    }, 200);
  });
